import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { installGlobalErrorHandlers } from "./lib/errorReporter";
import { armSplashFailsafe } from "./native/splashScreen";

installGlobalErrorHandlers();

// Before the first render, deliberately: `launchAutoHide` is off, so if the
// render below throws, only this timer is left to take the splash down. A
// no-op off native.
armSplashFailsafe();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
